import { TableType } from '../components/merchant/Enum/TableType';
import AppData from './AppData';

export default class Table {
    static isDineInWithPaymentTable() {
        if (AppData.data.state) {
            let table = AppData.data.state.table
            return (table.table_type_bitwise & TableType.BIT_DINE_IN_WITH_PAYMENT) > 0
        }
        return false
    }

    /**
     * Check if current table is Take Away table. Merchant can have multiple Take Away table
     * @returns Boolean
     */
     static isTakeAwayTable = (currentTableId) => {
        currentTableId = parseInt(currentTableId)
        const takeAwayTableId = AppData.data.getMerchantSettingValue('take_away_table_id')
        if (takeAwayTableId) {
            const tableIds = takeAwayTableId.split(",").map(tableId => parseInt((tableId || "").trim() || 0))
            // const currentTableId = parseInt(this.getCurrentTableId())
            if (tableIds.length && currentTableId && tableIds.indexOf(currentTableId) > -1) {
                return true
            }
        }
        return false
    }
}